const CITY = [
  // {
  //   "id": "000000",
  //   "CODE": "000000",
  //   "NAME": "全国",
  //   "PROVINCE_CODE": "000000"
  // },
  {
    "id": "110100",
    "CODE": "110100",
    "NAME": "北京市",
    "PROVINCE_CODE": "110000"
  },
  {
    "id": "120100",
    "CODE": "120100",
    "NAME": "天津市",
    "PROVINCE_CODE": "120000"
  },
  {
    "id": "130100",
    "CODE": "130100",
    "NAME": "石家庄市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130200",
    "CODE": "130200",
    "NAME": "唐山市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130300",
    "CODE": "130300",
    "NAME": "秦皇岛市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130400",
    "CODE": "130400",
    "NAME": "邯郸市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130500",
    "CODE": "130500",
    "NAME": "邢台市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130600",
    "CODE": "130600",
    "NAME": "保定市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130700",
    "CODE": "130700",
    "NAME": "张家口市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130800",
    "CODE": "130800",
    "NAME": "承德市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "130900",
    "CODE": "130900",
    "NAME": "沧州市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "131000",
    "CODE": "131000",
    "NAME": "廊坊市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "131100",
    "CODE": "131100",
    "NAME": "衡水市",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "139000",
    "CODE": "139000",
    "NAME": "河北省直辖县级行政区划",
    "PROVINCE_CODE": "130000"
  },
  {
    "id": "140100",
    "CODE": "140100",
    "NAME": "太原市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140200",
    "CODE": "140200",
    "NAME": "大同市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140300",
    "CODE": "140300",
    "NAME": "阳泉市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140400",
    "CODE": "140400",
    "NAME": "长治市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140500",
    "CODE": "140500",
    "NAME": "晋城市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140600",
    "CODE": "140600",
    "NAME": "朔州市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140700",
    "CODE": "140700",
    "NAME": "晋中市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140800",
    "CODE": "140800",
    "NAME": "运城市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "140900",
    "CODE": "140900",
    "NAME": "忻州市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "141000",
    "CODE": "141000",
    "NAME": "临汾市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "141100",
    "CODE": "141100",
    "NAME": "吕梁市",
    "PROVINCE_CODE": "140000"
  },
  {
    "id": "150100",
    "CODE": "150100",
    "NAME": "呼和浩特市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150200",
    "CODE": "150200",
    "NAME": "包头市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150300",
    "CODE": "150300",
    "NAME": "乌海市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150400",
    "CODE": "150400",
    "NAME": "赤峰市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150500",
    "CODE": "150500",
    "NAME": "通辽市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150600",
    "CODE": "150600",
    "NAME": "鄂尔多斯市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150700",
    "CODE": "150700",
    "NAME": "呼伦贝尔市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150800",
    "CODE": "150800",
    "NAME": "巴彦淖尔市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "150900",
    "CODE": "150900",
    "NAME": "乌兰察布市",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "152200",
    "CODE": "152200",
    "NAME": "兴安盟",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "152500",
    "CODE": "152500",
    "NAME": "锡林郭勒盟",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "152900",
    "CODE": "152900",
    "NAME": "阿拉善盟",
    "PROVINCE_CODE": "150000"
  },
  {
    "id": "210100",
    "CODE": "210100",
    "NAME": "沈阳市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210200",
    "CODE": "210200",
    "NAME": "大连市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210300",
    "CODE": "210300",
    "NAME": "鞍山市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210400",
    "CODE": "210400",
    "NAME": "抚顺市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210500",
    "CODE": "210500",
    "NAME": "本溪市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210600",
    "CODE": "210600",
    "NAME": "丹东市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210700",
    "CODE": "210700",
    "NAME": "锦州市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210800",
    "CODE": "210800",
    "NAME": "营口市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "210900",
    "CODE": "210900",
    "NAME": "阜新市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "211000",
    "CODE": "211000",
    "NAME": "辽阳市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "211100",
    "CODE": "211100",
    "NAME": "盘锦市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "211200",
    "CODE": "211200",
    "NAME": "铁岭市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "211300",
    "CODE": "211300",
    "NAME": "朝阳市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "211400",
    "CODE": "211400",
    "NAME": "葫芦岛市",
    "PROVINCE_CODE": "210000"
  },
  {
    "id": "220100",
    "CODE": "220100",
    "NAME": "长春市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220200",
    "CODE": "220200",
    "NAME": "吉林市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220300",
    "CODE": "220300",
    "NAME": "四平市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220400",
    "CODE": "220400",
    "NAME": "辽源市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220500",
    "CODE": "220500",
    "NAME": "通化市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220600",
    "CODE": "220600",
    "NAME": "白山市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220700",
    "CODE": "220700",
    "NAME": "松原市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "220800",
    "CODE": "220800",
    "NAME": "白城市",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "222400",
    "CODE": "222400",
    "NAME": "延边朝鲜族自治州",
    "PROVINCE_CODE": "220000"
  },
  {
    "id": "230100",
    "CODE": "230100",
    "NAME": "哈尔滨市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230200",
    "CODE": "230200",
    "NAME": "齐齐哈尔市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230300",
    "CODE": "230300",
    "NAME": "鸡西市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230400",
    "CODE": "230400",
    "NAME": "鹤岗市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230500",
    "CODE": "230500",
    "NAME": "双鸭山市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230600",
    "CODE": "230600",
    "NAME": "大庆市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230700",
    "CODE": "230700",
    "NAME": "伊春市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230800",
    "CODE": "230800",
    "NAME": "佳木斯市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "230900",
    "CODE": "230900",
    "NAME": "七台河市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "231000",
    "CODE": "231000",
    "NAME": "牡丹江市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "231100",
    "CODE": "231100",
    "NAME": "黑河市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "231200",
    "CODE": "231200",
    "NAME": "绥化市",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "232700",
    "CODE": "232700",
    "NAME": "大兴安岭地区",
    "PROVINCE_CODE": "230000"
  },
  {
    "id": "310100",
    "CODE": "310100",
    "NAME": "上海市",
    "PROVINCE_CODE": "310000"
  },
  {
    "id": "320100",
    "CODE": "320100",
    "NAME": "南京市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320200",
    "CODE": "320200",
    "NAME": "无锡市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320300",
    "CODE": "320300",
    "NAME": "徐州市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320400",
    "CODE": "320400",
    "NAME": "常州市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320500",
    "CODE": "320500",
    "NAME": "苏州市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320600",
    "CODE": "320600",
    "NAME": "南通市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320700",
    "CODE": "320700",
    "NAME": "连云港市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320800",
    "CODE": "320800",
    "NAME": "淮安市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "320900",
    "CODE": "320900",
    "NAME": "盐城市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "321000",
    "CODE": "321000",
    "NAME": "扬州市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "321100",
    "CODE": "321100",
    "NAME": "镇江市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "321200",
    "CODE": "321200",
    "NAME": "泰州市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "321300",
    "CODE": "321300",
    "NAME": "宿迁市",
    "PROVINCE_CODE": "320000"
  },
  {
    "id": "330100",
    "CODE": "330100",
    "NAME": "杭州市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330200",
    "CODE": "330200",
    "NAME": "宁波市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330300",
    "CODE": "330300",
    "NAME": "温州市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330400",
    "CODE": "330400",
    "NAME": "嘉兴市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330500",
    "CODE": "330500",
    "NAME": "湖州市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330600",
    "CODE": "330600",
    "NAME": "绍兴市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330700",
    "CODE": "330700",
    "NAME": "金华市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330800",
    "CODE": "330800",
    "NAME": "衢州市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "330900",
    "CODE": "330900",
    "NAME": "舟山市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "331000",
    "CODE": "331000",
    "NAME": "台州市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "331100",
    "CODE": "331100",
    "NAME": "丽水市",
    "PROVINCE_CODE": "330000"
  },
  {
    "id": "340100",
    "CODE": "340100",
    "NAME": "合肥市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340200",
    "CODE": "340200",
    "NAME": "芜湖市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340300",
    "CODE": "340300",
    "NAME": "蚌埠市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340400",
    "CODE": "340400",
    "NAME": "淮南市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340500",
    "CODE": "340500",
    "NAME": "马鞍山市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340600",
    "CODE": "340600",
    "NAME": "淮北市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340700",
    "CODE": "340700",
    "NAME": "铜陵市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "340800",
    "CODE": "340800",
    "NAME": "安庆市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341000",
    "CODE": "341000",
    "NAME": "黄山市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341100",
    "CODE": "341100",
    "NAME": "滁州市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341200",
    "CODE": "341200",
    "NAME": "阜阳市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341300",
    "CODE": "341300",
    "NAME": "宿州市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341500",
    "CODE": "341500",
    "NAME": "六安市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341600",
    "CODE": "341600",
    "NAME": "亳州市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341700",
    "CODE": "341700",
    "NAME": "池州市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "341800",
    "CODE": "341800",
    "NAME": "宣城市",
    "PROVINCE_CODE": "340000"
  },
  {
    "id": "350100",
    "CODE": "350100",
    "NAME": "福州市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350200",
    "CODE": "350200",
    "NAME": "厦门市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350300",
    "CODE": "350300",
    "NAME": "莆田市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350400",
    "CODE": "350400",
    "NAME": "三明市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350500",
    "CODE": "350500",
    "NAME": "泉州市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350600",
    "CODE": "350600",
    "NAME": "漳州市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350700",
    "CODE": "350700",
    "NAME": "南平市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350800",
    "CODE": "350800",
    "NAME": "龙岩市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "350900",
    "CODE": "350900",
    "NAME": "宁德市",
    "PROVINCE_CODE": "350000"
  },
  {
    "id": "360100",
    "CODE": "360100",
    "NAME": "南昌市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360200",
    "CODE": "360200",
    "NAME": "景德镇市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360300",
    "CODE": "360300",
    "NAME": "萍乡市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360400",
    "CODE": "360400",
    "NAME": "九江市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360500",
    "CODE": "360500",
    "NAME": "新余市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360600",
    "CODE": "360600",
    "NAME": "鹰潭市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360700",
    "CODE": "360700",
    "NAME": "赣州市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360800",
    "CODE": "360800",
    "NAME": "吉安市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "360900",
    "CODE": "360900",
    "NAME": "宜春市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "361000",
    "CODE": "361000",
    "NAME": "抚州市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "361100",
    "CODE": "361100",
    "NAME": "上饶市",
    "PROVINCE_CODE": "360000"
  },
  {
    "id": "370100",
    "CODE": "370100",
    "NAME": "济南市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370200",
    "CODE": "370200",
    "NAME": "青岛市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370300",
    "CODE": "370300",
    "NAME": "淄博市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370400",
    "CODE": "370400",
    "NAME": "枣庄市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370500",
    "CODE": "370500",
    "NAME": "东营市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370600",
    "CODE": "370600",
    "NAME": "烟台市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370700",
    "CODE": "370700",
    "NAME": "潍坊市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370800",
    "CODE": "370800",
    "NAME": "济宁市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "370900",
    "CODE": "370900",
    "NAME": "泰安市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371000",
    "CODE": "371000",
    "NAME": "威海市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371100",
    "CODE": "371100",
    "NAME": "日照市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371200",
    "CODE": "371200",
    "NAME": "莱芜市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371300",
    "CODE": "371300",
    "NAME": "临沂市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371400",
    "CODE": "371400",
    "NAME": "德州市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371500",
    "CODE": "371500",
    "NAME": "聊城市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371600",
    "CODE": "371600",
    "NAME": "滨州市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "371700",
    "CODE": "371700",
    "NAME": "菏泽市",
    "PROVINCE_CODE": "370000"
  },
  {
    "id": "410100",
    "CODE": "410100",
    "NAME": "郑州市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410200",
    "CODE": "410200",
    "NAME": "开封市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410300",
    "CODE": "410300",
    "NAME": "洛阳市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410400",
    "CODE": "410400",
    "NAME": "平顶山市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410500",
    "CODE": "410500",
    "NAME": "安阳市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410600",
    "CODE": "410600",
    "NAME": "鹤壁市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410700",
    "CODE": "410700",
    "NAME": "新乡市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410800",
    "CODE": "410800",
    "NAME": "焦作市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "410900",
    "CODE": "410900",
    "NAME": "濮阳市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411000",
    "CODE": "411000",
    "NAME": "许昌市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411100",
    "CODE": "411100",
    "NAME": "漯河市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411200",
    "CODE": "411200",
    "NAME": "三门峡市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411300",
    "CODE": "411300",
    "NAME": "南阳市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411400",
    "CODE": "411400",
    "NAME": "商丘市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411500",
    "CODE": "411500",
    "NAME": "信阳市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411600",
    "CODE": "411600",
    "NAME": "周口市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "411700",
    "CODE": "411700",
    "NAME": "驻马店市",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "419000",
    "CODE": "419000",
    "NAME": "河南省直辖县级行政区划",
    "PROVINCE_CODE": "410000"
  },
  {
    "id": "420100",
    "CODE": "420100",
    "NAME": "武汉市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420200",
    "CODE": "420200",
    "NAME": "黄石市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420300",
    "CODE": "420300",
    "NAME": "十堰市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420500",
    "CODE": "420500",
    "NAME": "宜昌市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420600",
    "CODE": "420600",
    "NAME": "襄阳市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420700",
    "CODE": "420700",
    "NAME": "鄂州市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420800",
    "CODE": "420800",
    "NAME": "荆门市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "420900",
    "CODE": "420900",
    "NAME": "孝感市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "421000",
    "CODE": "421000",
    "NAME": "荆州市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "421100",
    "CODE": "421100",
    "NAME": "黄冈市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "421200",
    "CODE": "421200",
    "NAME": "咸宁市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "421300",
    "CODE": "421300",
    "NAME": "随州市",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "422800",
    "CODE": "422800",
    "NAME": "恩施土家族苗族自治州",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "429000",
    "CODE": "429000",
    "NAME": "湖北省直辖县级行政区划",
    "PROVINCE_CODE": "420000"
  },
  {
    "id": "430100",
    "CODE": "430100",
    "NAME": "长沙市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430200",
    "CODE": "430200",
    "NAME": "株洲市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430300",
    "CODE": "430300",
    "NAME": "湘潭市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430400",
    "CODE": "430400",
    "NAME": "衡阳市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430500",
    "CODE": "430500",
    "NAME": "邵阳市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430600",
    "CODE": "430600",
    "NAME": "岳阳市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430700",
    "CODE": "430700",
    "NAME": "常德市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430800",
    "CODE": "430800",
    "NAME": "张家界市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "430900",
    "CODE": "430900",
    "NAME": "益阳市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "431000",
    "CODE": "431000",
    "NAME": "郴州市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "431100",
    "CODE": "431100",
    "NAME": "永州市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "431200",
    "CODE": "431200",
    "NAME": "怀化市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "431300",
    "CODE": "431300",
    "NAME": "娄底市",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "433100",
    "CODE": "433100",
    "NAME": "湘西土家族苗族自治州",
    "PROVINCE_CODE": "430000"
  },
  {
    "id": "440100",
    "CODE": "440100",
    "NAME": "广州市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440200",
    "CODE": "440200",
    "NAME": "韶关市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440300",
    "CODE": "440300",
    "NAME": "深圳市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440400",
    "CODE": "440400",
    "NAME": "珠海市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440500",
    "CODE": "440500",
    "NAME": "汕头市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440600",
    "CODE": "440600",
    "NAME": "佛山市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440700",
    "CODE": "440700",
    "NAME": "江门市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440800",
    "CODE": "440800",
    "NAME": "湛江市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "440900",
    "CODE": "440900",
    "NAME": "茂名市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441200",
    "CODE": "441200",
    "NAME": "肇庆市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441300",
    "CODE": "441300",
    "NAME": "惠州市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441400",
    "CODE": "441400",
    "NAME": "梅州市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441500",
    "CODE": "441500",
    "NAME": "汕尾市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441600",
    "CODE": "441600",
    "NAME": "河源市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441700",
    "CODE": "441700",
    "NAME": "阳江市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441800",
    "CODE": "441800",
    "NAME": "清远市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "441900",
    "CODE": "441900",
    "NAME": "东莞市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "442000",
    "CODE": "442000",
    "NAME": "中山市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "445100",
    "CODE": "445100",
    "NAME": "潮州市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "445200",
    "CODE": "445200",
    "NAME": "揭阳市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "445300",
    "CODE": "445300",
    "NAME": "云浮市",
    "PROVINCE_CODE": "440000"
  },
  {
    "id": "450100",
    "CODE": "450100",
    "NAME": "南宁市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450200",
    "CODE": "450200",
    "NAME": "柳州市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450300",
    "CODE": "450300",
    "NAME": "桂林市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450400",
    "CODE": "450400",
    "NAME": "梧州市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450500",
    "CODE": "450500",
    "NAME": "北海市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450600",
    "CODE": "450600",
    "NAME": "防城港市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450700",
    "CODE": "450700",
    "NAME": "钦州市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450800",
    "CODE": "450800",
    "NAME": "贵港市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "450900",
    "CODE": "450900",
    "NAME": "玉林市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "451000",
    "CODE": "451000",
    "NAME": "百色市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "451100",
    "CODE": "451100",
    "NAME": "贺州市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "451200",
    "CODE": "451200",
    "NAME": "河池市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "451300",
    "CODE": "451300",
    "NAME": "来宾市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "451400",
    "CODE": "451400",
    "NAME": "崇左市",
    "PROVINCE_CODE": "450000"
  },
  {
    "id": "460100",
    "CODE": "460100",
    "NAME": "海口市",
    "PROVINCE_CODE": "460000"
  },
  {
    "id": "460200",
    "CODE": "460200",
    "NAME": "三亚市",
    "PROVINCE_CODE": "460000"
  },
  {
    "id": "460300",
    "CODE": "460300",
    "NAME": "三沙市",
    "PROVINCE_CODE": "460000"
  },
  {
    "id": "460400",
    "CODE": "460400",
    "NAME": "儋州市",
    "PROVINCE_CODE": "460000"
  },
  {
    "id": "469000",
    "CODE": "469000",
    "NAME": "海南省直辖县级行政区划",
    "PROVINCE_CODE": "460000"
  },
  {
    "id": "500100",
    "CODE": "500100",
    "NAME": "重庆市辖区",
    "PROVINCE_CODE": "500000"
  },
  {
    "id": "500200",
    "CODE": "500200",
    "NAME": "重庆市辖县",
    "PROVINCE_CODE": "500000"
  },
  {
    "id": "510100",
    "CODE": "510100",
    "NAME": "成都市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510300",
    "CODE": "510300",
    "NAME": "自贡市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510400",
    "CODE": "510400",
    "NAME": "攀枝花市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510500",
    "CODE": "510500",
    "NAME": "泸州市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510600",
    "CODE": "510600",
    "NAME": "德阳市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510700",
    "CODE": "510700",
    "NAME": "绵阳市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510800",
    "CODE": "510800",
    "NAME": "广元市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "510900",
    "CODE": "510900",
    "NAME": "遂宁市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511000",
    "CODE": "511000",
    "NAME": "内江市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511100",
    "CODE": "511100",
    "NAME": "乐山市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511300",
    "CODE": "511300",
    "NAME": "南充市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511400",
    "CODE": "511400",
    "NAME": "眉山市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511500",
    "CODE": "511500",
    "NAME": "宜宾市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511600",
    "CODE": "511600",
    "NAME": "广安市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511700",
    "CODE": "511700",
    "NAME": "达州市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511800",
    "CODE": "511800",
    "NAME": "雅安市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "511900",
    "CODE": "511900",
    "NAME": "巴中市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "512000",
    "CODE": "512000",
    "NAME": "资阳市",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "513200",
    "CODE": "513200",
    "NAME": "阿坝藏族羌族自治州",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "513300",
    "CODE": "513300",
    "NAME": "甘孜藏族自治州",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "513400",
    "CODE": "513400",
    "NAME": "凉山彝族自治州",
    "PROVINCE_CODE": "510000"
  },
  {
    "id": "520100",
    "CODE": "520100",
    "NAME": "贵阳市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "520200",
    "CODE": "520200",
    "NAME": "六盘水市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "520300",
    "CODE": "520300",
    "NAME": "遵义市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "520400",
    "CODE": "520400",
    "NAME": "安顺市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "520500",
    "CODE": "520500",
    "NAME": "毕节市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "520600",
    "CODE": "520600",
    "NAME": "铜仁市",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "522300",
    "CODE": "522300",
    "NAME": "黔西南布依族苗族自治州",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "522600",
    "CODE": "522600",
    "NAME": "黔东南苗族侗族自治州",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "522700",
    "CODE": "522700",
    "NAME": "黔南布依族苗族自治州",
    "PROVINCE_CODE": "520000"
  },
  {
    "id": "530100",
    "CODE": "530100",
    "NAME": "昆明市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530300",
    "CODE": "530300",
    "NAME": "曲靖市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530400",
    "CODE": "530400",
    "NAME": "玉溪市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530500",
    "CODE": "530500",
    "NAME": "保山市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530600",
    "CODE": "530600",
    "NAME": "昭通市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530700",
    "CODE": "530700",
    "NAME": "丽江市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530800",
    "CODE": "530800",
    "NAME": "普洱市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "530900",
    "CODE": "530900",
    "NAME": "临沧市",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "532300",
    "CODE": "532300",
    "NAME": "楚雄彝族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "532500",
    "CODE": "532500",
    "NAME": "红河哈尼族彝族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "532600",
    "CODE": "532600",
    "NAME": "文山壮族苗族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "532800",
    "CODE": "532800",
    "NAME": "西双版纳傣族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "532900",
    "CODE": "532900",
    "NAME": "大理白族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "533100",
    "CODE": "533100",
    "NAME": "德宏傣族景颇族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "533300",
    "CODE": "533300",
    "NAME": "怒江傈僳族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "533400",
    "CODE": "533400",
    "NAME": "迪庆藏族自治州",
    "PROVINCE_CODE": "530000"
  },
  {
    "id": "540100",
    "CODE": "540100",
    "NAME": "拉萨市",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "540200",
    "CODE": "540200",
    "NAME": "日喀则市",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "540300",
    "CODE": "540300",
    "NAME": "昌都市",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "540400",
    "CODE": "540400",
    "NAME": "林芝市",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "540500",
    "CODE": "540500",
    "NAME": "山南市",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "542400",
    "CODE": "542400",
    "NAME": "那曲地区",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "542500",
    "CODE": "542500",
    "NAME": "阿里地区",
    "PROVINCE_CODE": "540000"
  },
  {
    "id": "610100",
    "CODE": "610100",
    "NAME": "西安市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610200",
    "CODE": "610200",
    "NAME": "铜川市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610300",
    "CODE": "610300",
    "NAME": "宝鸡市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610400",
    "CODE": "610400",
    "NAME": "咸阳市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610500",
    "CODE": "610500",
    "NAME": "渭南市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610600",
    "CODE": "610600",
    "NAME": "延安市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610700",
    "CODE": "610700",
    "NAME": "汉中市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610800",
    "CODE": "610800",
    "NAME": "榆林市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "610900",
    "CODE": "610900",
    "NAME": "安康市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "611000",
    "CODE": "611000",
    "NAME": "商洛市",
    "PROVINCE_CODE": "610000"
  },
  {
    "id": "620100",
    "CODE": "620100",
    "NAME": "兰州市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620200",
    "CODE": "620200",
    "NAME": "嘉峪关市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620300",
    "CODE": "620300",
    "NAME": "金昌市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620400",
    "CODE": "620400",
    "NAME": "白银市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620500",
    "CODE": "620500",
    "NAME": "天水市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620600",
    "CODE": "620600",
    "NAME": "武威市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620700",
    "CODE": "620700",
    "NAME": "张掖市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620800",
    "CODE": "620800",
    "NAME": "平凉市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "620900",
    "CODE": "620900",
    "NAME": "酒泉市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "621000",
    "CODE": "621000",
    "NAME": "庆阳市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "621100",
    "CODE": "621100",
    "NAME": "定西市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "621200",
    "CODE": "621200",
    "NAME": "陇南市",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "622900",
    "CODE": "622900",
    "NAME": "临夏回族自治州",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "623000",
    "CODE": "623000",
    "NAME": "甘南藏族自治州",
    "PROVINCE_CODE": "620000"
  },
  {
    "id": "630100",
    "CODE": "630100",
    "NAME": "西宁市",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "630200",
    "CODE": "630200",
    "NAME": "海东市",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632200",
    "CODE": "632200",
    "NAME": "海北藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632300",
    "CODE": "632300",
    "NAME": "黄南藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632500",
    "CODE": "632500",
    "NAME": "海南藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632600",
    "CODE": "632600",
    "NAME": "果洛藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632700",
    "CODE": "632700",
    "NAME": "玉树藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "632800",
    "CODE": "632800",
    "NAME": "海西蒙古族藏族自治州",
    "PROVINCE_CODE": "630000"
  },
  {
    "id": "640100",
    "CODE": "640100",
    "NAME": "银川市",
    "PROVINCE_CODE": "640000"
  },
  {
    "id": "640200",
    "CODE": "640200",
    "NAME": "石嘴山市",
    "PROVINCE_CODE": "640000"
  },
  {
    "id": "640300",
    "CODE": "640300",
    "NAME": "吴忠市",
    "PROVINCE_CODE": "640000"
  },
  {
    "id": "640400",
    "CODE": "640400",
    "NAME": "固原市",
    "PROVINCE_CODE": "640000"
  },
  {
    "id": "640500",
    "CODE": "640500",
    "NAME": "中卫市",
    "PROVINCE_CODE": "640000"
  },
  {
    "id": "650100",
    "CODE": "650100",
    "NAME": "乌鲁木齐市",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "650200",
    "CODE": "650200",
    "NAME": "克拉玛依市",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "650400",
    "CODE": "650400",
    "NAME": "吐鲁番市",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "650500",
    "CODE": "650500",
    "NAME": "哈密市",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "652300",
    "CODE": "652300",
    "NAME": "昌吉回族自治州",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "652700",
    "CODE": "652700",
    "NAME": "博尔塔拉蒙古自治州",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "652800",
    "CODE": "652800",
    "NAME": "巴音郭楞蒙古自治州",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "652900",
    "CODE": "652900",
    "NAME": "阿克苏地区",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "653000",
    "CODE": "653000",
    "NAME": "克孜勒苏柯尔克孜自治州",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "653100",
    "CODE": "653100",
    "NAME": "喀什地区",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "653200",
    "CODE": "653200",
    "NAME": "和田地区",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "654000",
    "CODE": "654000",
    "NAME": "伊犁哈萨克自治州",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "654200",
    "CODE": "654200",
    "NAME": "塔城地区",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "654300",
    "CODE": "654300",
    "NAME": "阿勒泰地区",
    "PROVINCE_CODE": "650000"
  },
  {
    "id": "659000",
    "CODE": "659000",
    "NAME": "新疆维吾尔自治区自治区直辖县级行政区划",
    "PROVINCE_CODE": "650000"
  }
]

export default CITY